export default "__VITE_ASSET__LgH4FhVL__"